/*
  useIsMobile.js
*/

// Npm.
import { useState, useEffect } from 'react';

// Hooks.
import useTheme from './useTheme';

/**
 * Returns true if window matches the size and gOE (greater-or-equal).
 */
function windowMatchesWidth(size, gOE = false) {
  return gOE === (window.innerWidth >= size);
}

/**
 * Hook to return whether the browser is below/above a certain size or not.
 */
export default function useIsSize(size, gOE = false) {

  const theme = useTheme();

  let width;
  switch (size) {
    case 'xs':  width = theme.xs; break;
    case 'sm':  width = theme.sm; break;
    case 'md':  width = theme.md; break;
    case 'lg':  width = theme.lg; break;
    default:    width = 0;
  }

  const [isMatch, setIsMatch] = useState(windowMatchesWidth(width, gOE));

  useEffect(() => {

    function handleResize(event) {
      setIsMatch(windowMatchesWidth(width, gOE));
    }

    window.addEventListener('resize', handleResize, false);

    return () => {
      window.removeEventListener('resize', handleResize, false);
    };

  }, [width, gOE]);

  return isMatch;

}
